<template>
  <div>
    <md-button
      v-if="canAddSubfamily"
      :disabled="loading"
      @click="prepareCreate"
      class="floating md-rose md-just-icon md-round"
    >
      <md-icon>add</md-icon>
    </md-button>
    <md-toolbar class="md-rose" md-elevation="1">
      <div class="md-layout">
        <div class="md-layout-item md-size-40">
          <h3 class="md-title">SubFamilia</h3>
        </div>
        <div class="md-layout-item md-size-60">
          <md-field md-inline>
            <label>Buscar</label>
            <md-input class="sizeBox" v-model="searchQuery"></md-input>
          </md-field>
        </div>
      </div>
    </md-toolbar>
    <md-list class="md-triple-line">
      <md-content class="md-scrollbar" v-if="queriedData.length">
        <div v-for="(fam, i) in queriedData" :key="fam.id">
          <md-divider class="md-inset"></md-divider>
          <md-list-item
            @mouseover="showIcons(i)"
            @click="filterItem(fam)"
            :class="clickedSubFamily === fam ? 'selected-subfamily' : ''"
          >
            <div class="md-list-item-text">
              <span>{{ fam.name }}</span>
              <span>
                <strong>ID</strong>
                {{ fam.id }}
              </span>
              <p>
                <strong>Codigo</strong>
                {{ fam.codename }}
              </p>
            </div>
            <div v-if="currentlyShow === i">
              <md-button
                v-if="canChangeSubfamily"
                class="md-primary md-just-icon md-round edit"
                @click="prepareEdit(fam)"
              >
                <md-icon>edit</md-icon>
              </md-button>
              <md-button
                v-if="canDeleteSubfamily"
                class="md-primary md-just-icon md-round edit"
                @click="deleteItem(fam)"
              >
                <md-icon>delete</md-icon>
              </md-button>
            </div>
          </md-list-item>
        </div>
      </md-content>
      <loading-content
        v-else
        empty-icon="account_tree"
        empty-label="No hay subfamilias que mostrar."
        :empty-description="emptyDescription"
      />
    </md-list>
    <editModal
      v-if="classicModal"
      :editedItem="item"
      :familyId="familyId"
      @saved="updateElement"
      @close="classicModalHide"
      @error="classicModalHide"
    ></editModal>
  </div>
</template>

<script>
import dataService from "@/services/catalog";
import { mapGetters } from "vuex";
import editModal from "./createSubFamily";
import Fuse from "fuse.js";
import mapPermissions from "@/plugins/accountPermissions/mapPermissions";

export default {
  props: {
    familyId: 0,
    loading: {
      type: Boolean,
    },
  },
  components: {
    editModal,
  },
  data() {
    return {
      item: {},
      search: "",
      classicModal: false,
      hover: false,
      currentlyShow: null,
      fuseSearch: null,
      propsToSearch: ["name", "codename"],
      searchQuery: "",
      searchedData: [],
      clickedSubFamily: null,
    };
  },
  computed: {
    ...mapPermissions("Services", "subfamily"),
    ...mapGetters({ filterFamily: "catalogs/filterSubFamily" }),

    subFamilies() {
      return this.filterFamily(this.familyId);
    },

    /* subFamilies */

    queriedData() {
      let result = this.subFamilies;
      if (this.searchedData && this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result;
    },

    emptyDescription() {
      if (!this.familyId) {
        return "Seleccione una familia para ver sus subfamilias.";
      }
      return "La familia seleccionada no tiene subfamilias.";
    },
  },
  methods: {
    filterItem(item) {
      this.clickedSubFamily = item;
      this.$emit("subFamily", item.id);
    },
    showIcons(index) {
      this.hover = true;
      this.currentlyShow = index;
    },
    prepareCreate() {
      this.isRegister = true;
      this.item = {};
      this.classicModal = true;
    },
    prepareEdit(c) {
      // get element selected from table
      this.item = c; // make copy of element selected
      this.isRegister = false; // Modal in mode edition
      this.classicModal = true; // show modal
    },
    classicModalHide() {
      this.classicModal = false;
    },

    // CURD Methods

    deleteItem(c) {
      this.$confirmMessage({ title: "¿Estas seguro?" }, () => {
        return dataService
          .delete("services/subfamilies", c, { useStore: true })
          .then(() => this.$successMessage({ title: "Borrado" }))
          .catch(this.$fireErrorResponse);
      });
    },

    updateElement({ original, updated }) {
      // excecute when the form is valid
      this.classicModalHide();
      if (!original.id) {
        this.createdE(updated);
      } else {
        this.editElement(updated, original);
      }
    },

    createdE(h) {
      dataService
        .create("services/subfamilies", h, { useStore: true })
        .then((item) =>
          this.$successMessage({
            title: `Creando Familia de Insumos: ${item.name}`,
          })
        )
        .catch(this.$fireErrorResponse);
    },

    editElement(updated, original) {
      dataService
        .update("services/subfamilies", updated, original, { useStore: true })
        .then(
          (h) => this.$successMessage({ title: `${h.name} fue Editado` }),
          this.$fireErrorResponse
        );
    },
  },

  mounted() {
    dataService
      .fetch("services/subfamilies", { useStore: true })
      .then(() => {})
      .catch(this.$fireErrorResponse);

    this.fuseSearch = new Fuse(this.subFamilies, {
      threshold: 0.3,
      keys: this.propsToSearch,
    });
  },

  watch: {
    subFamilies(newList) {
      this.fuseSearch.list = newList;
      const [first] = newList;
      if (first) {
        this.filterItem(first);
      }
    },

    searchQuery(value) {
      let result;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~vue-material/dist/theme/engine"; // Import the theme engine
.floating {
  width: 40px !important;
  height: 40px !important;
  position: absolute;
  top: 78px;
  left: 8px;
  z-index: 2;
}

.md-content {
  max-height: 70vh;
  overflow: auto;
}
.sizeBox {
  max-width: 100%;
  min-width: 100%;
}
.md-button.md-fab,
.md-button.md-just-icon {
  z-index: 4;
}
.selected-subfamily {
  background-color: md-get-palette-color(pink, 100);
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Supplies/Existence/ListSubFamily.vue